import React, { useEffect, useState } from 'react';
import { TableCell, TableRow, Box, useTheme } from '@mui/material';
import TableView from "./util/TableView";
import { ModuleHeader } from "../../components/composed";
import { Badge } from "../../components/primitives";
import { FadeIn } from "../../components/motion";

export default function GrinchesView(props) {
  const theme = useTheme();

  const [data, setData] = useState([]);

  useEffect(() => {
    props.setShowSearch(true);
  }, []);


  const tableHeader =
    <TableRow>
      <TableCell>Name</TableCell>
      <TableCell>Comment</TableCell>
      <TableCell>Location</TableCell>
      <TableCell>Active</TableCell>
    </TableRow>;

  const tableRows = (row) =>
    <TableRow
      sx={{ cursor: 'pointer' }}
      key={row.id}
    >
      <TableCell>{row.name}</TableCell>
      <TableCell>
        <Box sx={{ whiteSpace: 'pre-line' }}>{row.comment}</Box>
      </TableCell>
      <TableCell>{row.city}, {row.country}</TableCell>
      <TableCell>
        <Badge
          variant={row.isActive ? 'success' : 'neutral'}
          size="small"
        >
          {row.isActive ? 'Active' : 'Inactive'}
        </Badge>
      </TableCell>
    </TableRow>;


  return (
    <FadeIn>
      <ModuleHeader
        title="Grinches"
        subtitle="Manage Secret Santa participants excluded from the event"
        moduleColor={theme.palette.santa?.main || theme.palette.success.main}
      />
      <TableView
        fetchUrl={"grinches"}
        tableHeader={tableHeader}
        tableRows={tableRows}
        searchValue={props.searchValue}
        data={data}
        setData={setData}
        {...props}
      />
    </FadeIn>
  );
}
